<template>
  <v-app>
    <transition
        name="fade"
        mode="out-in"
      >
      <router-view/>
    </transition>
    <v-overlay z-index="203" color="rgba(255, 255, 255, 0.9)" :value="this.$store.state.loader">
      <v-progress-circular color="primary" indeterminate :width="7" size="64"></v-progress-circular>
    </v-overlay>
  </v-app>
</template>

<script>
import HelloWorld from './components/HelloWorld';

export default {
  name: 'App',
  components: {
    HelloWorld,
  },
  data: () => ({
    //
  }),
  beforeCreate() {
  },
  created() {
    let viewHeight = window.innerHeight
    let viewWidth =  window.innerWidth
    let viewport = document.querySelector("meta[name=viewport]");
    viewport.setAttribute("content", "height=" + viewHeight + "px, width=" + viewWidth + "px, initial-scale=1.0");
    var testStore = this.$store;
    var appOneSignalId = process.env.VUE_APP_ONESIGNAL_APP_ID
    //console.log(appOneSignalId)
    OneSignal.push(function() {
      OneSignal.init({
        appId: appOneSignalId,
        allowLocalhostAsSecureOrigin: process.env.NODE_ENV !== 'production',
      });
      OneSignal.on('subscriptionChange', function (isSubscribed) {
        let userIdApp = testStore.state.user.id;
        if (isSubscribed == true) {
            OneSignal.setExternalUserId(userIdApp);
            OneSignal.getExternalUserId().then(function (id) {
                console.log("OneSignal thinks playerID is " + id);
            });
            testStore.dispatch("disableNotif", {id_utilisateur: userIdApp, webpush: "OUI" })
        }
        else if (isSubscribed == false) {
            console.log('Not suscribed');
            testStore.dispatch("disableNotif", {id_utilisateur: userIdApp, webpush: "NON" })
        }
        else {
            console.log('Unable to process the request');
            testStore.dispatch("disableNotif", {id_utilisateur: userIdApp, webpush: "NON" })
        }
    });

    OneSignal.on('notificationPermissionChange', function (permissionChange) {
        var currentPermission = permissionChange.to;
        let userIdApp = testStore.state.user.id;
        console.log("Notif permission equals: " + (currentPermission === 'granted'));
        if (currentPermission === 'granted') {
            console.log("Notif Setting user playerID as "+ userIdApp);
            OneSignal.setExternalUserId(userIdApp).then(function (response) {
                console.log("Notif OneSignal's response is " + response);
            });

            OneSignal.getExternalUserId().then(function (id) {
                console.log("Notif OneSignal thinks playerID is " + id);
            });
        }
    });

    var isPushSupported = OneSignal.isPushNotificationsSupported();
      if (!isPushSupported) {
        console.log('Notif not possible ')
        testStore.dispatch("disableNotif", {id_utilisateur: userIdApp, webpush: "NON" })
      }
    
    });

    


  },
}; 
</script>

<style lang="scss">
  #app {
    font-family:'Open Sans';
    min-height:100vh;
    background-color:#f3f5fa;
    word-wrap: none;
    
  }
</style>
